export default __webpack_public_path__ + "static/media/about-world-map-circle.50f40f06.svg";